var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgListe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Liste__Icn/40px/Liste",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Liste__Color/Transp_00",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40V40H0z",
    id: ".._.._src_svg_Icn_40px_Liste__Rectangle"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15,12 L31,12 L31,14 L15,14 Z M10,12 L12,12 L12,14 L10,14 Z M15,19 L31,19 L31,21 L15,21 Z M10,19 L12,19 L12,21 L10,21 Z M15,26 L31,26 L31,28 L15,28 Z M10,26 L12,26 L12,28 L10,28 Z",
    id: ".._.._src_svg_Icn_40px_Liste__Combined-Shape"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListe);
export default __webpack_public_path__ + "static/media/Liste.6be420b562b40981b5510022bcf1776d.svg";
export { ForwardRef as ReactComponent };